<template>
  <div
    class="confirmation"
    :class="{
      active: opened == true,
      'confirmation--centered': centered == true
    }"
  >
    <div class="confirmation__overlay" />
    <div class="confirmation__box d-flex flex-column justify-content-center">
      <div class="confirmation__box__text">
        {{ title }}?
      </div>
      <div
        class="confirmation__box__buttons d-flex align-items-center justify-content-center"
      >
        <button class="btn btn-outline-primary mr-3" @click="close()">
          {{ $t("zpet") }}
        </button>
        <button
          class="btn btn-primary d-flex align-items-center justify-content-center"
          @click="yes()"
        >
          {{ $t("odstranit") }}
          <span v-if="items.length > 1" class="px-1">{{ items.length }}</span>
          {{ $t(text) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
//import _ from "lodash";
//import axios from "axios";
export default {
  props: {
    title: String,
    text: String,
    opened: Boolean,
    items: Array,
    centered: Boolean
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    yes() {
      this.$emit("yes");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped></style>
